import { OrganizationPropertyName } from 'organization/model/organization-property-name';
import { OrganizationPropertyType } from 'organization/model/organization-property-type';

export interface IOrganizationProperty {
	readonly name: OrganizationPropertyName;
	readonly type: OrganizationPropertyType;
	readonly value: string;
}

export class OrganizationProperty {
	private _name: OrganizationPropertyName;
	private _type: OrganizationPropertyType;
	private _value: string;

	constructor(
		name: OrganizationPropertyName,
		type: OrganizationPropertyType,
		value: string
	) {
		this._name = name;
		this._type = type;
		this._value = value;
	}

	public get name(): OrganizationPropertyName {
		return this._name;
	}

	public get type(): OrganizationPropertyType {
		return this._type;
	}

	public get value(): string {
		return this._value;
	}
}
